import { cva, type VariantProps } from 'class-variance-authority'

/**
 * PriceInfo variants - For product view price display
 *
 * Design tokens from tailwind.config.js:
 * - text-color (#1c1b21) - Main text color
 * - custom-red (#d7263d) - Final/discount price color
 * - second-btn-bg - Tooltip background
 * - font-main-font (Poppins) - Price font
 */

export const priceInfoWrapperVariants = cva([
  'flex flex-col items-center md:items-start justify-start pl-5',
])

export const priceInfoStrikethroughVariants = cva([
  'font-main-font text-lg xl:text-xl text-text-color line-through',
])

export const priceInfoFinalPriceVariants = cva([
  'font-main-font text-2xl xl:text-4xl font-bold text-custom-red mr-5',
])

export const priceInfoVatVariants = cva([
  'font-main-font text-lg xl:text-xl text-text-color font-normal',
])

export const priceInfoMsrpVariants = cva([
  'font-main-font text-lg xl:text-xl text-text-color',
])

export const priceInfoTooltipVariants = cva([
  'max-w-[300px] min-w-[200px] absolute bottom-10 p-2',
  'border rounded-md shadow-lg',
  'text-white text-lg font-main-font text-center bg-second-btn-bg',
])

// Type exports
export type PriceInfoWrapperVariants = VariantProps<typeof priceInfoWrapperVariants>
export type PriceInfoStrikethroughVariants = VariantProps<typeof priceInfoStrikethroughVariants>
export type PriceInfoFinalPriceVariants = VariantProps<typeof priceInfoFinalPriceVariants>
export type PriceInfoVatVariants = VariantProps<typeof priceInfoVatVariants>
export type PriceInfoMsrpVariants = VariantProps<typeof priceInfoMsrpVariants>
export type PriceInfoTooltipVariants = VariantProps<typeof priceInfoTooltipVariants>
